import { Feature } from "./join-the-conversation/feature"
import { CommentAndReactImage } from "./join-the-conversation/comment-and-react-image"
import { PollsAndMoreImage } from "./join-the-conversation/polls-and-more-image"
import { FollowerChatImage } from "./join-the-conversation/follower-chat-image"

type FeatureItem = {
  title: string
  image: React.ReactNode
}

const FEATURES: FeatureItem[] = [
  {
    title: "COMMENT & REACT",
    image: <CommentAndReactImage />,
  },
  {
    title: "POLLS, AMAs, TRIVIA & MORE",
    image: <PollsAndMoreImage />,
  },
  {
    title: "CONNECT IN THE MEMBER CHAT",
    image: <FollowerChatImage />,
  },
]

export function JoinTheConversationSection() {
  return (
    <div className="relative flex w-full flex-col items-center justify-center bg-gradient-to-b from-sky-blue to-light-pastel-blue pt-8">
      <div className="mx-auto w-full max-w-5xl">
        <div className="flex flex-col items-center justify-center">
          <div className="text-42">🤝</div>

          <p className="px-8 text-center font-md-nichrome text-44 font-bold uppercase leading-[48px] text-black md:px-0 md:text-60">
            Join the conversation
          </p>
        </div>

        <div className="flex w-full flex-col items-center justify-center pt-6">
          {FEATURES.map((feature) => (
            <Feature key={feature.title} title={feature.title} image={feature.image} />
          ))}
        </div>
      </div>
    </div>
  )
}
